"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _6P52IAFYcjs = require('./6P52IAFY.cjs');


var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/hovercard/hovercard-context.tsx
var ctx = _PTOCUU2Dcjs.createStoreContext.call(void 0, 
  [_6P52IAFYcjs.PopoverContextProvider],
  [_6P52IAFYcjs.PopoverScopedContextProvider]
);
var useHovercardContext = ctx.useContext;
var useHovercardScopedContext = ctx.useScopedContext;
var useHovercardProviderContext = ctx.useProviderContext;
var HovercardContextProvider = ctx.ContextProvider;
var HovercardScopedContextProvider = ctx.ScopedContextProvider;







exports.useHovercardContext = useHovercardContext; exports.useHovercardScopedContext = useHovercardScopedContext; exports.useHovercardProviderContext = useHovercardProviderContext; exports.HovercardContextProvider = HovercardContextProvider; exports.HovercardScopedContextProvider = HovercardScopedContextProvider;
